/* SpaceArmory PDP v2: review link, manual measurement calculator, size-range check.
   Purchase state lives in SpaceArmoryPurchaseController (global.js); this file only drives v2 extras. */
(() => {
  if (window.SpaceArmoryPdpV2) return;
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Judge.me review widget anchor.
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-sa-v2-reviews-link]');
    if (!link) return;
    const widget = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget, .jdgm-widget.jdgm-review-widget');
    if (!widget) return;
    event.preventDefault();
    widget.scrollIntoView({behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start'});
  });

  // Size ranges come from the canonical rules; correct the server-rendered labels if they drift.
  function ranges() {
    const rules = window.SpaceArmoryFitRules;
    if (!rules) return null;
    const found = {};
    for (let tenth = 100; tenth <= 200; tenth++) {
      const cm = tenth / 10;
      const size = rules.sizeFor(cm);
      if (!size) continue;
      found[size] ??= {min: cm, max: cm};
      found[size].max = cm;
    }
    Object.values(found).forEach(range => { range.max = Math.ceil(range.max); });
    return found;
  }
  function verifyRanges(scope = document) {
    const found = ranges();
    if (!found) return;
    scope.querySelectorAll('[data-sa-v2-range]').forEach(label => {
      const key = {SMALL: 'S', MEDIUM: 'M', LARGE: 'L', 'X-LARGE': 'XL', 'EXTRA LARGE': 'XL', '2XL': 'XXL', 'XX-LARGE': 'XXL'}[label.dataset.saV2Range] || label.dataset.saV2Range;
      const range = found[key];
      if (!range) return;
      const text = `${range.min}–${range.max} cm`;
      if (label.textContent !== text) label.textContent = text;
    });
  }

  // Manual guide: type the measured length, get the size, apply it through the purchase controller.
  function unitOf(guide) {
    return guide.querySelector('[data-unit][aria-selected="true"]')?.dataset.unit === 'cm' ? 'cm' : 'in';
  }
  function updateCalc(guide) {
    const calc = guide.querySelector('[data-sa-v2-calc]');
    if (!calc) return;
    const input = calc.querySelector('[data-sa-v2-calc-input]');
    const result = calc.querySelector('[data-sa-v2-calc-result]');
    const use = calc.querySelector('[data-sa-v2-calc-use]');
    const unit = unitOf(guide);
    calc.querySelector('[data-sa-v2-calc-unit]').textContent = unit;
    input.placeholder = unit === 'cm' ? 'e.g. 13.5' : 'e.g. 5.3';
    const raw = parseFloat(input.value.replace(',', '.'));
    const cm = Number.isFinite(raw) ? (unit === 'in' ? raw * 2.54 : raw) : NaN;
    const size = Number.isFinite(cm) ? window.SpaceArmoryFitRules?.sizeFor(cm) : null;
    guide.querySelectorAll('.manual-size-guide__table tbody tr').forEach(row => {
      row.classList.toggle('sa-v2-calc-hit', !!size && row.querySelector('th')?.textContent.trim() === size);
    });
    calc.dataset.size = size || '';
    use.hidden = !size;
    if (!input.value.trim()) { result.textContent = ''; return; }
    if (size) {
      result.innerHTML = '';
      const strong = document.createElement('strong');
      strong.textContent = size;
      result.append('Your Size: ', strong, ` (${cm.toFixed(1)} cm)`);
      use.textContent = `Use Size ${size}`;
    } else if (Number.isFinite(cm)) {
      result.textContent = cm < 12 ? 'Under 12 cm. Please measure again, or choose S.' : 'Over 17 cm. Please measure again, or choose XXL.';
    } else {
      result.textContent = 'Enter a number, e.g. 5.3';
    }
  }
  document.addEventListener('input', event => {
    const guide = event.target.closest('[data-sa-v2-calc-input]') && event.target.closest('manual-size-guide');
    if (guide) updateCalc(guide);
  });
  document.addEventListener('click', event => {
    const guide = event.target.closest('manual-size-guide');
    if (!guide || !guide.querySelector('[data-sa-v2-calc]')) return;
    if (event.target.closest('[data-unit]')) { requestAnimationFrame(() => updateCalc(guide)); return; }
    if (!event.target.closest('[data-sa-v2-calc-use]')) return;
    const size = guide.querySelector('[data-sa-v2-calc]').dataset.size;
    const purchase = guide.closest('product-info')?.faceFitPurchase;
    if (!size || !purchase) return;
    const result = guide.querySelector('[data-sa-v2-calc-result]');
    try {
      purchase.applySize(size);
      guide.close?.();
    } catch (error) {
      result.textContent = error.message === 'variant_unavailable' ? `Size ${size} is sold out.` : `Size ${size} isn't available for this mask.`;
    }
  });

  window.SpaceArmoryPdpV2 = {verifyRanges};
  const init = () => verifyRanges();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Variant changes re-render the picker from the server; re-check after each swap.
  document.addEventListener('change', event => {
    if (event.target.closest('variant-selects')) setTimeout(() => verifyRanges(), 400);
  });
})();
